import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/flex")({
	component: FlexLayout,
});

function FlexLayout() {
	return <Outlet />;
}
